import React from 'react';
import { AppRoute, AppRoutes } from '../../routes';
import { Route, Switch } from 'react-router';
import { AddManageDeviceProfile } from './AddManageDeviceProfile';
import { ManageDeviceProfiles } from './ManageDeviceProfiles';
import { DeviceMasterProvider } from '../../data/DataProviders/DeviceMasterProvider';

type Props = {
    tabVal?: string;
    testId?: string;
    appRoute: AppRoute;
};

export const ManageDeviceProfilesContainer: React.FC<Props> = () => <Switch>
            <Route exact path={AppRoutes.ManageDeviceProfiles}>
                <DeviceMasterProvider>
                    <ManageDeviceProfiles />
                </DeviceMasterProvider>
            </Route>
            <Route exact path={AppRoutes.AddManageDeviceProfile} component={AddManageDeviceProfile} />
        </Switch>

